import GuidanceItem from './_parts/GuidanceItem/GuidanceItem';
import { itemsMaterial, itemsObject } from './Guidance.data';
import { useGuidance } from './Guidance.hooks';
import { Wrapper } from './Guidance.style';
import { BoxPair } from './Guidance.types';

export type GuidanceProps = {
  editMode: EditMode;
  onCta: () => void;
  onCancel: () => void;
};

export function Guidance(props: GuidanceProps) {
  const { editMode } = props;
  const pairs = useGuidance(editMode === 'material' ? itemsMaterial : itemsObject);

  function renderPair(pair: BoxPair) {
    return <GuidanceItem key={pair.item.id} pair={pair} />;
  }

  function renderPairs() {
    return pairs.map((pair: BoxPair) => renderPair(pair));
  }

  return (
    <Wrapper className='Guidance-wrapper' data-testid='Guidance-wrapper' onClick={props.onCta}>
      {renderPairs()}
    </Wrapper>
  );
}

export default Guidance;
